import { render, staticRenderFns } from "./WorkTypeCategoryTable.vue?vue&type=template&id=361e902c&"
import script from "./WorkTypeCategoryTable.vue?vue&type=script&lang=js&"
export * from "./WorkTypeCategoryTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports